import {Typography} from '@mui/material';
import {TechnicalIssuePriority} from '@services/TechnicalSupport/types';
import {useEnumDictionary} from 'utils/hooks/useEnumDictionary';

export const priorityCellColor = {
    [TechnicalIssuePriority.HIGH]: 'var(--mui-palette-error-main)',
    [TechnicalIssuePriority.MEDIUM]: 'var(--mui-palette-warning-main)',
    [TechnicalIssuePriority.LOW]: 'var(--mui-palette-text-primary)',
};

export const TechnicalSupportTablePriorityCell = (_rowId: any, value: TechnicalIssuePriority) => {
    const {getOptionNameByCode} = useEnumDictionary({code: 'SupportTicketPriority'});

    return (
        <Typography
            fontSize={14}
            sx={{color: priorityCellColor[value as TechnicalIssuePriority]}}
        >
            {getOptionNameByCode(value)}
        </Typography>
    );
};
